var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhoneOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.82051C2 3.26279 3.26279 2 4.82051 2H8.18384C8.9564 2 9.64229 2.49436 9.8866 3.22728L11.4228 7.83594C11.7053 8.68332 11.3217 9.60945 10.5227 10.0089L8.89192 10.8243C9.86864 12.6374 11.3626 14.1314 13.1757 15.1081L13.9911 13.4773C14.3906 12.6783 15.3167 12.2947 16.1641 12.5772L20.7727 14.1134C21.5056 14.3577 22 15.0436 22 15.8162V19.1795C22 20.7372 20.7372 22 19.1795 22H18.1538C9.23232 22 2 14.7677 2 5.84615V4.82051ZM4.82051 3.53846C4.11246 3.53846 3.53846 4.11246 3.53846 4.82051V5.84615C3.53846 13.918 10.082 20.4615 18.1538 20.4615H19.1795C19.8875 20.4615 20.4615 19.8875 20.4615 19.1795V15.8162C20.4615 15.7058 20.3909 15.6078 20.2862 15.5729L15.6776 14.0367C15.5565 13.9963 15.4242 14.0511 15.3671 14.1653L14.2096 16.4804C14.0249 16.8497 13.5817 17.0073 13.2054 16.8377C10.5269 15.63 8.36996 13.4731 7.16235 10.7946C6.99266 10.4183 7.15033 9.97507 7.51959 9.79044L9.83473 8.63287C9.94886 8.5758 10.0037 8.4435 9.96331 8.32244L8.42709 3.71379C8.39219 3.60909 8.2942 3.53846 8.18384 3.53846H4.82051Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoneOrange);
export default __webpack_public_path__ + "static/media/icon-phone-orange.63220dd227749915b9485426d8a37ff2.svg";
export { ForwardRef as ReactComponent };